const clientId = process.env.VUE_APP_NAVER_CLIENT_ID;
const NAVER_AUTH_URL = "https://nid.naver.com/oauth2.0/authorize";

const generateState = () =>
  Math.random().toString(36).substring(2, 15) +
  Math.random().toString(36).substring(2, 15);

export default function requestNaverAuthCode(callbackUrl) {
  const state = generateState();

  const params = new URLSearchParams({
    response_type: "code",
    client_id: clientId,
    redirect_uri: callbackUrl,
    state: state,
  });

  // 브라우저를 네이버 인증 페이지로 리다이렉트
  window.location.href = `${NAVER_AUTH_URL}?${params.toString()}`;
}
